import { useEffect, useState } from 'react';
import { getApiBaseUrl } from '../../../utils/apiConfig';
import { sortReincidenciaHistoricoItems } from '../utils/orderDetailsReincidenciaUtils';

export function useOrderDetailsReincidenciaHistorico(orderId, enabled) {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const id = String(orderId ?? '').trim();
    if (!enabled || !id) {
      setItems([]);
      setError(null);
      setLoading(false);
      return undefined;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    const token = localStorage.getItem('authToken');
    fetch(`${getApiBaseUrl()}/api/orders/${encodeURIComponent(id)}/reincidencia-historico`, {
      headers: {
        Authorization: token ? `Bearer ${token}` : '',
        'Content-Type': 'application/json',
      },
    })
      .then((res) => res.json())
      .then((json) => {
        if (cancelled) return;
        if (json?.success && Array.isArray(json.data)) {
          setItems(sortReincidenciaHistoricoItems(json.data));
        } else {
          setItems([]);
          setError(json?.message || 'Não foi possível carregar o histórico de reincidência.');
        }
      })
      .catch(() => {
        if (!cancelled) {
          setItems([]);
          setError('Erro ao carregar histórico de reincidência.');
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [orderId, enabled]);

  return { items, loading, error };
}
